import BaseView from '../../../js/base-view';

const SELECTOR_INNER = '.section-card__inner';
const SELECTOR_CARD = '.card-shop';
const SELECTOR_NAV_BUTTON = '.section-card__nav-button';
const SELECTOR_NAV_BUTTON_PREV = '.section-card__nav-button--prev';
const SELECTOR_NAV_BUTTON_NEXT = '.section-card__nav-button--next';

const CLASS_BUTTON_DISABLED = 'is-disabled';

export default class CardsShopList extends BaseView {
	/**
	 * Entrypoint
	 */
	init() {
		this.refs = {
			inner: this.el.querySelector(SELECTOR_INNER),
			cards: Array.from(this.el.querySelectorAll(SELECTOR_CARD)),
			navButtonPrev: this.el.querySelector(SELECTOR_NAV_BUTTON_PREV),
			navButtonNext: this.el.querySelector(SELECTOR_NAV_BUTTON_NEXT),
		};

		if (this.refs.inner && this.refs.navButtonPrev && this.refs.navButtonNext) {
			this.initNavigation();
		}

		return this;
	}

	// --------------------------------
	// #region Navigation
	// --------------------------------

	initNavigation() {
		this.on('click', SELECTOR_NAV_BUTTON, this.handleNavButtonClick.bind(this));
		this.refs.inner.addEventListener('scroll', this.updateNavButtonsState.bind(this));
		this.on('resize', this.updateNavButtonsState.bind(this));
		this.updateNavButtonsState();
	}

	handleNavButtonClick(event) {
		event.preventDefault();
		event.stopPropagation();
		
		const button = event.target.closest(SELECTOR_NAV_BUTTON);
		const direction = button?.getAttribute('data-direction');
		if (!direction || !this.refs.inner) {
			return;
		}

		const scrollContainer = this.refs.inner;
		const cardWidth = this.getCardWidth();
		const gap = this.getGap();
		const scrollAmount = cardWidth + gap;

		let targetScroll = scrollContainer.scrollLeft;
		if (direction === 'previous') {
			targetScroll = Math.max(0, targetScroll - scrollAmount);
		}
		else {
			targetScroll = Math.min(
				scrollContainer.scrollWidth - scrollContainer.clientWidth,
				targetScroll + scrollAmount
			);
		}

		scrollContainer.scrollTo({
			left: targetScroll,
			behavior: 'smooth',
		});
	}

	getCardWidth() {
		if (!this.refs.cards.length) {
			return 0;
		}
		const firstCard = this.refs.cards[0];
		const cardRect = firstCard.getBoundingClientRect();
		return cardRect.width;
	}

	getGap() {
		if (!this.refs.inner) {
			return 0;
		}
		const style = window.getComputedStyle(this.refs.inner);
		const gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 0;
		return gap;
	}

	updateNavButtonsState() {
		if (!this.refs.inner || !this.refs.navButtonPrev || !this.refs.navButtonNext) {
			return;
		}

		const scrollContainer = this.refs.inner;
		const scrollLeft = scrollContainer.scrollLeft;
		const scrollWidth = scrollContainer.scrollWidth;
		const clientWidth = scrollContainer.clientWidth;
		const maxScroll = scrollWidth - clientWidth;

		const isAtStart = scrollLeft <= 1;
		const isAtEnd = scrollLeft >= maxScroll - 1;

		this.refs.navButtonPrev.classList[isAtStart ? 'add' : 'remove'](CLASS_BUTTON_DISABLED);
		this.refs.navButtonPrev.disabled = isAtStart;
		this.refs.navButtonPrev.tabIndex = isAtStart ? -1 : 0;

		this.refs.navButtonNext.classList[isAtEnd ? 'add' : 'remove'](CLASS_BUTTON_DISABLED);
		this.refs.navButtonNext.disabled = isAtEnd;
		this.refs.navButtonNext.tabIndex = isAtEnd ? -1 : 0;
	}

	// --------------------------------
	// #endregion
	// --------------------------------
}

